module.exports = __webpack_public_path__ + "img/AUCALogo.d76c5893.jpg";